import React, { useState, useEffect } from "react";
import "./MyProfile.css";
import { API_BASE_URL, LOGOUT_URL } from "./config";
import { showAlert } from "./showAlert";
import { useLoading } from "./LoadingContext";
import { FaDownload } from "react-icons/fa";
// import { useFee } from "./FeeContext";
import {
} from "./PaymentConfig";

import { OFFICE_CONTACT_NUMBER } from "./PaymentConfig";

function MyProfile() {
  const apiUrl = API_BASE_URL;
  const logoutUrl = LOGOUT_URL;
  const [loading, setLoading] = useState(true);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [originalProfilePhoto, setOriginalProfilePhoto] = useState(null);
  // eslint-disable-next-line
  const [GetuserDetails, setGetUserDetails] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [MBerrorMessage, setMBErrorMessage] = useState("");
  const { showLoading, hideLoading } = useLoading();
  const [showPaymentUI, setShowPaymentUI] = useState(false);
  const [activeTab, setActiveTab] = useState("history");
  // const [feePaidSince, setFeePaidSince] = useState(0);
   const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const [payments, setPayments] = useState([]);
  // eslint-disable-next-line
  const [error, setError] = useState("");
  // const { feeData } = useFee();

  const [userDetails, setUserDetails] = useState({
    student_unique_id: "NA",
    Admission_date: "NA",
    image: "NA", //for image
    first_name: "NA",
    last_name: "NA",
    email: "NA",
    mobileNumber: "NA",
    education: "NA",
    dob: "NA",
    // Add more details as needed
  });

  const fetchProfilePhoto = async (studentUniqueId, token) => {
    try {
      const timestamp = new Date().getTime(); // Generate a unique timestamp
      const photoUrl = `${apiUrl}/get_profile_photo/${studentUniqueId}?token=${token}&t=${timestamp}`;

      setProfilePhoto(photoUrl);
      setOriginalProfilePhoto(photoUrl);
    } catch (error) {
      console.error("Error fetching profile photo:", error);
    }
  };

  const handleCancelSelection = () => {
    setSelectedPhoto(null);
    setProfilePhoto(originalProfilePhoto); // Revert to the original image
    setMBErrorMessage("");

    // Reset file input field
    document.getElementById("fileInput").value = "";
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      showLoading("💾 Retrieving your profile information... Just a moment!");

      try {
        const studentUniqueId = localStorage.getItem("student_unique_id");
        const token = localStorage.getItem("token");
        if (studentUniqueId && token) {
          const response = await fetch(
            `${apiUrl}/student_info/${studentUniqueId}?token=${token}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
              },
            }
          );

          if (response.status === 403) {
            alert(
              "You seem to be logged in on another device/browser. Logging out from here."
            );
            localStorage.removeItem("student_unique_id");
            localStorage.removeItem("token");
            window.location.href = logoutUrl;
            return;
          }

          if (response.status === 401) {
            alert("Your session has expired. Please log in again.");
            localStorage.removeItem("student_unique_id");
            localStorage.removeItem("token");
            window.location.href = logoutUrl;
            return;
          }
          if (response.ok) {
            console.log("Fetched Data Is :");
            const data = await response.json();
            setGetUserDetails(data);
            console.log(data);
            setUserDetails({
              Admission_date: data.creation_datetime
                ? data.creation_datetime.split("T")[0]
                : "",

              student_unique_id: data.student_unique_id,
              image: data.image, //for image
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              mobileNumber: data.mobile_number,
              education: data.education,
              dob: data.dob ? data.dob.split("T")[0] : "",
              // Add more details as needed
            });

            fetchProfilePhoto(studentUniqueId, token);
          } else {
            console.error("Failed to fetch user details:", response.statusText);
          }
        } else {
          console.error("Student Unique ID not found in local storage");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setLoading(false);
        await sleep(700);
        hideLoading();
      }
    };

    fetchUserDetails();

    // eslint-disable-next-line
  }, []);

  // State to track edit mode for each field
  const [editMode, setEditMode] = useState({
    image: false,
    first_name: false,
    last_name: false,
    email: false,
    mobileNumber: false,
    education: false,
    dob: false,
    student_unique_id: false,
    Admission_date: false,
    // Add more fields as needed
  });

  // Function to handle edit mode toggle
  const toggleEditMode = (field) => {
    setEditMode({ ...editMode, [field]: !editMode[field] });
  };

  // Function to handle input change
  const handleInputChange = (e, field) => {
    let value = e.target.value;

    // Apply character-only rule for specific fields
    if (field === "first_name" || field === "last_name") {
      value = value.replace(/[^a-zA-Z]/g, ""); // only letters
    }

    setUserDetails({ ...userDetails, [field]: value });
  };

  const handleSave = async (field) => {
    console.log("handle save click");

    console.log(field);
    if (
      (field === "first_name" &&
        userDetails.first_name.toLowerCase() ===
          (userDetails.last_name || "").toLowerCase()) ||
      (field === "last_name" &&
        userDetails.last_name.toLowerCase() ===
          (userDetails.first_name || "").toLowerCase())
    ) {
      showAlert("❌ First name and last name cannot be the same.");
      return;
    }

    toggleEditMode(field);

    try {
      const studentUniqueId = localStorage.getItem("student_unique_id");
      const token = localStorage.getItem("token");
      if (studentUniqueId && token) {
        const response = await fetch(
          `${apiUrl}/update_student_info/${studentUniqueId}?token=${token}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ [field]: userDetails[field] }),
          }
        );

        if (response.status === 403) {
          alert(
            "You seem to be logged in on another device/browser. Logging out from here."
          );
          localStorage.removeItem("student_unique_id");
          localStorage.removeItem("token");
          window.location.href = logoutUrl;
          return;
        }

        if (response.status === 401) {
          alert("Your session has expired. Please log in again.");
          localStorage.removeItem("student_unique_id");
          localStorage.removeItem("token");
          window.location.href = logoutUrl;
          return;
        }
        if (!response.ok) {
          throw new Error(`Failed to update ${field}: ${response.statusText}`);
        }
      } else {
        console.error("Student Unique ID not found in local storage");
      }
    } catch (error) {
      console.error(`Error updating ${field}:`, error);
    }
  };

  // const handlelogout = () => {
  //   localStorage.removeItem("student_unique_id");
  //   localStorage.removeItem("token");
  //   window.location.href = logoutUrl;
  // };

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      // ✅ Check if it's an image
      if (!file.type.startsWith("image/")) {
        setSelectedPhoto(null);

        showAlert("❌ Only image files are allowed.");

        event.target.value = "";
        return;
      }
    }

    if (file) {
      const maxSize = 5 * 1024 * 1024;

      if (file.size > maxSize) {
        setSelectedPhoto(null);

        showAlert("📂 File size should be less than 5MB.");

        event.target.value = "";
        return;
      }

      setMBErrorMessage("");

      const imageURL = URL.createObjectURL(file); // Create a URL for the selected file
      setSelectedPhoto(file);
      setProfilePhoto(imageURL); // Set the profile photo to the selected photo's URL
    }
  };

  const handlePhotoUpload = async () => {
    if (!selectedPhoto) {
      showAlert("🖼️ Please select a photo first!");
      return;
    }

    const studentUniqueId = localStorage.getItem("student_unique_id");
    const token = localStorage.getItem("token");

    if (!studentUniqueId || !token) {
      console.error("Student Unique ID or token not found in local storage");
      return;
    }

    const formData = new FormData();
    formData.append("photo", selectedPhoto);
    showLoading("📸 Updating your profile picture... Hang tight!");

    try {
      const response = await fetch(
        `${apiUrl}/update_profile_photo/${studentUniqueId}?token=${token}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.status === 403) {
        alert(
          "You seem to be logged in on another device/browser. Logging out from here."
        );
        localStorage.removeItem("student_unique_id");
        localStorage.removeItem("token");
        window.location.href = logoutUrl;
        return;
      }

      if (response.status === 401) {
        alert("Your session has expired. Please log in again.");
        localStorage.removeItem("student_unique_id");
        localStorage.removeItem("token");
        window.location.href = logoutUrl;
        return;
      }

      if (response.ok) {
        showAlert("✨ Profile photo updated successfully!");

        // Force refresh the updated image
        fetchProfilePhoto(studentUniqueId, token);

        setSelectedPhoto(null); // Reset the file input
      } else {
        console.error("Failed to update profile photo:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating profile photo:", error);
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  const fetchPaymentHistory = async () => {
    const studentUniqueId = localStorage.getItem("student_unique_id");
    const token = localStorage.getItem("token");

    if (!studentUniqueId || !token) {
      console.error("Student Unique ID or token not found in local storage");
      return;
    }

    const API_URL = `${API_BASE_URL}/get-student-payment-history/${studentUniqueId}?token=${token}`;
    setError(""); // Reset error state

    try {
      const response = await fetch(API_URL);

      if (response.status === 403) {
        alert(
          "You seem to be logged in on another device/browser. Logging out from here."
        );
        localStorage.removeItem("student_unique_id");
        localStorage.removeItem("token");
        window.location.href = logoutUrl;
        return;
      }

      if (response.status === 401) {
        alert("Your session has expired. Please log in again.");
        localStorage.removeItem("student_unique_id");
        localStorage.removeItem("token");
        window.location.href = logoutUrl;
        return;
      }
      if (!response.ok) {
        throw new Error("Failed to fetch payment history");
      }

      if (response.status === 200) {
        const data = await response.json();
        const payments = data.payments || [];

        // Filter out payments where flag is not 'enrollment_fee'
        // const totalFeePaid = payments
        //   .filter((payment) => payment.flag !== "enrollment_fee")
        //   .reduce((sum, payment) => sum + (payment.amount_without_gst || 0), 0);

        setPayments(payments); // Set the full payments list
        // setFeePaidSince(totalFeePaid);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleViewPaymentHistory = async () => {
    await fetchPaymentHistory(); // Fetch payment history
    setShowPaymentUI(true); // Show the payment UI
  };

  const handleDownload = async (
    invoice_number,
    student_id,
    timestamp,
    amount
  ) => {
    console.log(invoice_number, student_id, timestamp, amount);

    const studentUniqueId = localStorage.getItem("student_unique_id");
    const token = localStorage.getItem("token");

    if (!studentUniqueId || !token) {
      console.error("Student Unique ID or token not found in local storage");
      return;
    }
    try {
      showLoading("⏱️ Invoice is being processed. Please hold on!");
      const response = await fetch(
        `${API_BASE_URL}/download-invoice/?invoice_number=${invoice_number}&student_id=${student_id}&token=${token}&timestamp=${encodeURIComponent(
          timestamp
        )}&amount=${amount}`,
        { method: "GET" }
      );

      if (response.status === 403) {
        alert(
          "You seem to be logged in on another device/browser. Logging out from here."
        );
        localStorage.removeItem("student_unique_id");
        localStorage.removeItem("token");
        window.location.href = logoutUrl;
        return;
      }

      if (response.status === 401) {
        alert("Your session has expired. Please log in again.");
        localStorage.removeItem("student_unique_id");
        localStorage.removeItem("token");
        window.location.href = logoutUrl;
        return;
      }

      if (!response.ok) throw new Error("Failed to download invoice");

      if (response.status === 200) {
        const blob = await response.blob();
        await sleep(700);
        hideLoading();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `invoice_${invoice_number}.pdf`;
        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Error downloading invoice:", error);
      alert("Failed to download invoice. Please try again.");
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  // const admissionDate = new Date(userDetails.Admission_date);
  // const today = new Date();
  // const timeDiff = today - admissionDate;
  // const daysSince = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;

  return (
    <div>

      {!showPaymentUI && (
        <>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="user-details-container">
              <div className="photo-side">
                <div>
                  <div className="user-image">
                    {profilePhoto ? (
                      <img src={profilePhoto} alt="User" />
                    ) : (
                      <img src="logo512.png" alt="Default User" />
                    )}
                  </div>

                  <input
                    type="file"
                    id="fileInput"
                    accept="image/*"
                    onChange={handlePhotoChange}
                    style={{ display: "none" }}
                  />
                </div>

                <div>
                  {!selectedPhoto ? (
                    <button
                      className="change-btn"
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      Update Photo
                    </button>
                  ) : (
                    <>
                      <button
                        className="change-btn"
                        onClick={handlePhotoUpload}
                      >
                        Submit Update
                      </button>
                      <button
                        className="change-btn cancel-btn"
                        onClick={handleCancelSelection}
                      >
                        Cancel
                      </button>
                    </>
                  )}
                </div>
                {/* PREMIUM STUDENT PROFILE EXPERIENCE V1 */}
                <div className="student-profile-identity">
                  <span className="student-profile-identity-label">
                    STUDENT IDENTITY
                  </span>
                  <h2>
                    {userDetails.first_name} {userDetails.last_name}
                  </h2>
                  <span className="student-profile-id">
                    {userDetails.student_unique_id}
                  </span>
                  <div className="student-profile-identity-meta">
                    <span>SNEHACHIEVERS TECH AI</span>
                    <span>Admitted: {userDetails.Admission_date}</span>
                  </div>
                </div>
              </div>

              {MBerrorMessage}

              <div className="user-details-section">
                {/* PROFILE PAYMENT BUTTON ALIGNMENT V1 */}
                <div className="student-profile-section-title">
                  <div className="student-profile-heading-row">
                    <div>
                      <span>MY ACCOUNT</span>
                      <h2>Personal &amp; Academic Information</h2>
                      <p>
                        Review your student details and keep your editable
                        information accurate.
                      </p>
                    </div>

                    <button
                      type="button"
                      className="payment-history-btn profile-payment-action"
                      onClick={handleViewPaymentHistory}
                    >
                      <span aria-hidden="true">▤</span>
                      Payment History &amp; Invoices
                    </button>
                  </div>
                </div>
                <div className="detail">
                  <div className="div1">
                    <label>student_id:</label>
                  </div>
                  <div className="div2">
                    {editMode.dob ? (
                      <input
                        type="text"
                        value={userDetails.student_unique_id}
                        onChange={(e) =>
                          handleInputChange(e, "student_unique_id")
                        }
                      />
                    ) : (
                      <span>{userDetails.student_unique_id}</span>
                    )}
                  </div>
                  <div className="div3"></div>
                </div>

                <div className="detail">
                  <div className="div1">
                    <label>Admission_date:</label>
                  </div>
                  <div className="div2">
                    {editMode.dob ? (
                      <input
                        type="text"
                        value={userDetails.Admission_date}
                        onChange={(e) => handleInputChange(e, "Admission_date")}
                      />
                    ) : (
                      <span>{userDetails.Admission_date}</span>
                    )}
                  </div>
                  <div className="div3"></div>
                </div>

                <div className="detail">
                  <div className="div1">
                    <label>First Name:</label>
                  </div>
                  <div className="div2">
                    {editMode.first_name ? (
                      <input
                        type="text"
                        value={userDetails.first_name}
                        onChange={(e) => handleInputChange(e, "first_name")}
                        maxLength={50}
                      />
                    ) : (
                      <span>{userDetails.first_name}</span>
                    )}
                  </div>
                  <div className="div3">
                    {editMode.first_name ? (
                      <button
                        className="change-btn"
                        onClick={() => handleSave("first_name")}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        className="change-btn"
                        onClick={() => toggleEditMode("first_name")}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </div>
                <div className="detail">
                  <div className="div1">
                    <label>Last Name:</label>
                  </div>
                  <div className="div2">
                    {editMode.last_name ? (
                      <input
                        type="text"
                        value={userDetails.last_name}
                        onChange={(e) => handleInputChange(e, "last_name")}
                        maxLength={50}
                      />
                    ) : (
                      <span>{userDetails.last_name}</span>
                    )}
                  </div>
                  <div className="div3">
                    {editMode.last_name ? (
                      <button
                        className="change-btn"
                        onClick={() => handleSave("last_name")}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        className="change-btn"
                        onClick={() => toggleEditMode("last_name")}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </div>
                <div className="detail">
                  <div className="div1">
                    <label>Email:</label>
                  </div>
                  <div className="div2">
                    {editMode.email ? (
                      <input
                        type="text"
                        value={userDetails.email}
                        onChange={(e) => handleInputChange(e, "email")}
                      />
                    ) : (
                      <span>{userDetails.email}</span>
                    )}
                  </div>
                  <div className="div3"></div>
                </div>
                <div className="detail">
                  <div className="div1">
                    <label>Mobile Number:</label>
                  </div>
                  <div className="div2">
                    {editMode.mobileNumber ? (
                      <input
                        type="text"
                        value={userDetails.mobileNumber}
                        onChange={(e) => handleInputChange(e, "mobileNumber")}
                      />
                    ) : (
                      <span>{userDetails.mobileNumber}</span>
                    )}
                  </div>
                  <div className="div3"></div>
                </div>
                <div className="detail">
                  <div className="div1">
                    <label>Date of Birth:</label>
                  </div>
                  <div className="div2">
                    {editMode.dob ? (
                      <input
                        type="text"
                        value={userDetails.dob}
                        onChange={(e) => handleInputChange(e, "dob")}
                      />
                    ) : (
                      <span>{userDetails.dob}</span>
                    )}
                  </div>
                  <div className="div3"></div>
                </div>
                <div className="student-profile-academic-divider">
                  <span>ACADEMIC DETAILS</span>
                  <h3>Your Educational Background</h3>
                </div>
                <div className="detail">
                  <div className="div1">
                    <label>Education:</label>
                  </div>
                  <div className="div2">
                    {editMode.education ? (
                      <input
                        type="text"
                        value={userDetails.education}
                        onChange={(e) => handleInputChange(e, "education")}
                        maxLength={50}
                      />
                    ) : (
                      <span>{userDetails.education}</span>
                    )}
                  </div>
                  <div className="div3">
                    {editMode.education ? (
                      <button
                        className="change-btn"
                        onClick={() => handleSave("education")}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        className="change-btn"
                        onClick={() => toggleEditMode("education")}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </div>
                {/* Add more details as needed */}
              </div>
            </div>
          )}
        </>
      )}

      {showPaymentUI && (
        <div className="payment-ui-container">
          {/* Top Navigation with Close Button */}
          <div className="payment-nav">
            <button
              className={`nav-btn ${activeTab === "history" ? "active" : ""}`}
              onClick={() => setActiveTab("history")}
            >
              📜 View Payment History & Download Invoice
            </button>
            <button
              className={`nav-btn ${activeTab === "breakdown" ? "active" : ""}`}
              onClick={() => setActiveTab("breakdown")}
            >
              📊 View Payment Breakdown
            </button>
            <button
              className="close-btn"
              onClick={() => setShowPaymentUI(false)}
            >
              ❌ Close
            </button>
          </div>

          {/* Content Section */}
          <div className="payment-content">
            {activeTab === "history" ? (
              <div className="history-section">
                {/* PREMIUM PAYMENT HISTORY V3 */}
                <div className="premium-payment-heading">
                  <div>
                    <span>YOUR FINANCIAL RECORDS</span>
                    <h2>Payment History &amp; Invoices</h2>
                    <p>
                      Review your recorded payments, GST breakdown
                      and download your invoices.
                    </p>
                  </div>
                  <div className="premium-payment-count">
                    <strong>{payments.length}</strong>
                    <span>Recorded Payments</span>
                  </div>
                </div>
                <div className="payment-list">
                  <div className="payment-card">
                    <div className="payment-details">
                      <p className="payment-amount Head">Payment Date</p>

                      <p className="payment-amount Head">Pyament Type</p>
                      <p className="payment-amount Head">Fee Paid</p>

                      <p className="payment-amount Head">GST (18%) GOI 🇮🇳</p>
                      <p className="payment-amount Head">Total Fee</p>
                    </div>
                  </div>
                  {payments.map((payment, index) => (
                    <div key={index} className="payment-card">
                      <div className="payment-details">
                        <p className="payment-date">
                          {payment.last_payment_timestamp}
                        </p>
                        <p className="payment-info">{payment.flag}</p>
                        <p className="payment-amount">
                          ₹{payment.amount_without_gst.toFixed(2)}
                        </p>

                        <p className="payment-amount">
                          ₹{payment.gst_amount.toFixed(2)}
                        </p>
                        <p className="payment-amount">
                          ₹{payment.total_amount.toFixed(2)}
                        </p>
                      </div>
                      <button
                        className="download-button"
                        onClick={() =>
                          handleDownload(
                            payment.invoice_number,
                            userDetails.student_unique_id,
                            payment.last_payment_timestamp,
                            payment.total_amount
                          )
                        }
                      >
                        <FaDownload />
                        <span>Invoice</span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="breakdown-section">
                <div className="b-payment-title">
                  Your Program Fee Structure — 2 Payments
                </div>

                <div className="b-payment-container student-two-fee-grid">
                  <div className="b-payment-card b-one-time">
                    <span className="student-fee-stage">
                      01 — Before Program Starts
                    </span>
                    <h3>Program Learning Fee</h3>
                    <p>₹32,500</p>
                    <small>Including GST</small>
                  </div>

                  <div className="b-payment-card b-partly-remaining">
                    <span className="student-fee-stage">
                      02 — After Placement
                    </span>
                    <h3>Post-Placement Fee</h3>
                    <p className="student-after-placement-text">
                      Pay After First Salary
                    </p>
                    <small>Amount as per agreed fee terms</small>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="support-bar">
        <p>
          For any queries or assistance, feel free to reach out to the{" "}
          <strong>StudyAIPlacement</strong> support team. We're here to help! 📞{" "}
          <a
            href={`tel:${OFFICE_CONTACT_NUMBER}`}
            style={{
              textDecoration: "none",
              color: "white",
              fontWeight: "bold",
            }}
          >
            {OFFICE_CONTACT_NUMBER}
          </a>
        </p>
      </div>
    </div>
  );
}

export default MyProfile;
